/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SmsTemplateResponse
 */
export interface SmsTemplateResponse {
    /**
     * 
     * @type {string}
     * @memberof SmsTemplateResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SmsTemplateResponse
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof SmsTemplateResponse
     */
    content: string;
}

/**
 * Check if a given object implements the SmsTemplateResponse interface.
 */
export function instanceOfSmsTemplateResponse(value: object): value is SmsTemplateResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function SmsTemplateResponseFromJSON(json: any): SmsTemplateResponse {
    return SmsTemplateResponseFromJSONTyped(json, false);
}

export function SmsTemplateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SmsTemplateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'content': json['content'],
    };
}

export function SmsTemplateResponseToJSON(json: any): SmsTemplateResponse {
    return SmsTemplateResponseToJSONTyped(json, false);
}

export function SmsTemplateResponseToJSONTyped(value?: SmsTemplateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'content': value['content'],
    };
}

